import React from 'react';

const SvgPasswordShown = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.874 11.595c-6.617-8.779-12.9-8.779-19.686-.088-.25.354-.25.71 0 .975 6.786 8.69 13.069 8.69 19.686 0a.845.845 0 000-.887zm-9.743-2.544c1.712 0 3.14 1.328 3.14 3.006 0 1.678-1.428 3.007-3.14 3.007-1.713 0-3.069-1.329-3.069-3.007 0-1.678 1.356-3.006 3.069-3.006z",
  fillRule: "evenodd"
}));

export default SvgPasswordShown;